import styled from 'styled-components';

const FooterStyles = styled.footer`
  background: ${props => props.theme.gray800};
  padding: 30px 0;
  color: white;
  a {
    color: ${props => props.theme.gray500};
    border-radius: 10px;
    transition: all 0.2s;
    color: ${props => props.theme.gray500};
    &:hover {
      text-decoration: underline;
    }
  }
  .foot-notes {
    ul {
      list-style: none;
      padding: 0;
      font-size: 0.8125rem;
      li {
        margin-bottom: 5px;
      }
    }
    p {
      font-size: 0.8125rem;
      color: ${props => props.theme.gray500};
      margin: 0;
      &.phone-wrap {
        a {
          color: ${props => props.theme.gray500};
        }
        ${props => props.theme.media.md} {
          text-align: right;
        }
      }
    }
  }
  .foot-notes {
    ul {
      li {
        ${props => props.theme.media.md} {
          display: inline-block;
          margin-right: 30px;
        }
      }
    }
    ${props => props.theme.media.lg} {
      .term-links-col {
        order: 1;
      }
    }
  }
`;

export default FooterStyles;
